"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropDownButton = void 0;

var _styles = require("./styles");

var _dropDownArrowButton = _interopRequireDefault(require("../../../assets/images/dropDownButton/dropDownArrowButton.svg"));

var _jsxRuntime = require("react/jsx-runtime");

var DropDownButton = function DropDownButton(_ref) {
  var active = _ref.active;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Container, {
    className: active && "active",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      src: _dropDownArrowButton.default,
      alt: "V"
    })
  });
};

exports.DropDownButton = DropDownButton;